module.exports = renderMathInElement;